import React from 'react';
import EventFeed from '../event-feed';
import { FEED_TYPES, FEED_VIEW_MODES } from '../event-feed/static';

const CampaignAuditTrail = props => (
  <EventFeed
    {...props}
    feedType={FEED_TYPES.CAMPAIGN}
    viewMode={FEED_VIEW_MODES.TABLE}
    hasExportFeature
  />
);

export default CampaignAuditTrail;



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-audit-trail/index.js
 **/